import {Component, Prop} from 'vue-property-decorator';
import {ValidationProvider} from 'vee-validate';
import BaseInput from '../Input/base-input';

@Component({
    components: {
        ValidationProvider,
    },
})
export default class BaseTimePickerComponent extends BaseInput {
    @Prop({
        default: () => ({
            label: '',
        }),
        type: Object,
    })
    fieldProps!: object;

    dialog = false;

    @Prop({
        type: String,
        default: 'ampm',
    })
    private readonly format?: string;

    public update(val: any) {
        this.$emit('update:value', val);
    }

    get DateValue() {
        const oldVal = this.value ?? '';

        if (this.format === 'ampm') {
            return oldVal ? this.$helpers.timeConvert(this.value as any) : null;
        }
        // if (oldVal.length <= 10) {
        //     oldVal = `${oldVal} 00:00:00`;
        // }
        console.log(this.value);
        // if (!!oldVal) {
        //     return new Date(oldVal);
        // }
        return oldVal;
    }
}
